import { gql } from '@apollo/client';

export const PARTNER_BASE_TYPES_QUERY = gql`
  query baseTypes {
    baseTypes {
      id
      name
    }
  }
`;

export const PARTNER_TYPES_DICTIONARY_QUERY = gql`
  query partnerTypesDictionary {
    partnerTypesDictionary {
      id
      name
    }
  }
`;
